import type { App, DevtoolsPluginApi } from "@vue/devtools-api";
import { setupDevtoolsPlugin } from "@vue/devtools-api";

export let devToolsApi: DevtoolsPluginApi<any> | null = null;

const setupDevtools = (app: App) => {
  setupDevtoolsPlugin(
    {
      id: "brewman-custom-devtools-plugin",
      label: "Brewman Custom DevTools",
      packageName: "brewman-custom-devtools-plugin",
      app,
    },
    (api) => {
      devToolsApi = api;
    }
  );
};

export default {
  install(Vue: App) {
    Vue.mixin({
      beforeCreate() {
        if (this.$options.devtoolsPlugin) {
          setupDevtools(this);
        }
      },
    });
  },
};
